export default "/images/logo-moneyview.png";